import Vue from 'vue'
import Router from 'vue-router'
import i18n from './plugins/i18n'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/sgp/online-payment/' : '/',
  routes: [
    {
      path: '/',
      redirect: '/en'
    },
    {
      path: '/:lang',
      name: 'home',
      component: Home,
      meta: {
        metaTags: [
          {
            name: 'description',
            content: 'The home page of our example app.'
          },
          {
            property: 'og:description',
            content: 'The home page of our example app.'
          }
        ]
      }
    }
  ]
})

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {

  // Set locale using route param
  const language = to.params.lang
  i18n.locale = language

  next()
})

export default router
